<template>
    <loading v-if="loading" message="Загружаем историю звонков..."></loading>
    <div v-else-if="!order.clientPhone" class="alert alert-danger">
        В данном заказе не задан телефон клиента, поэтому система не может загрузить звонки. Пожалуйста укажите номер телефона клиента, отредактировав заказ
    </div>
    <div v-else-if="items && items.length > 0">
        <div class="row mb-1 admin__list__item admin__list__item_hover-bg-gray" v-for="(item, index) in items">
            <div class="col-1 text-muted small">{{item.date}} в {{item.time}}</div>
            <div class="col-2 text-muted small">
                <template v-if="item.virtualNumber">
                    <span v-if="item.virtualNumber">{{item.virtualNumber.number}}</span>
                    <span v-if="item.virtualNumber && item.virtualNumber.city"><br>{{item.virtualNumber.city.name}}</span>
                    <span v-if="item.virtualNumber"><br>{{item.virtualNumber.site}}</span>
                </template>
            </div>
            <div class="col-4">
                <template v-if="item.internalNumber">
                    Ответил: {{item.internalNumber.number}}
                    <span class="badge badge-info" v-for="(user, index) in item.internalNumber.users">
                        <router-link v-if="currentUser.isAdmin" :to="{ name: 'ViewProfile', params: { id: user.id }}">{{user.fullname}}</router-link>
                        <template v-else>{{user.fullname}}</template>
                    </span>
                </template>
                <template v-else>
                <span class="badge badge-danger">
                    Не отвечен
                </span>
                </template>
            </div>
            <div class="col-5 text-muted small">
                <template v-if="item.internalNumber">
                    <template v-if="item.records">
                        <audio v-for="record in item.records" ref="player" controls>
                            <source :src="record.url">
                            Ваш браузер не поддрживает воспроизведение аудио записей
                        </audio>
                    </template>
                    <loading v-else-if="loadingRecords === item.pbxCallId" :size="2" message="Загружаем записи..."></loading>
                    <b-button v-else size="sm" variant="secondary" @click.prevent="loadRecords(item.pbxCallId, index)">Загрузить запись</b-button>
                </template>
                <template v-else>Запись разговора отсутсвует, т.к. звонок не был отвечен</template>
            </div>
        </div>
        <b-pagination class="mb-0" size="md" :total-rows="itemsPage.paginator.total_count" v-model="params.page" :per-page="itemsPage.paginator.limit">
        </b-pagination>
    </div>
    <div v-else class="alert alert-warning">
        Входящие звонки по данному заказу к сожалению не найдены.
    </div>
</template>
<script>
  import { mapActions, mapState } from 'vuex'
  import { ADD_TOAST_MESSAGE } from 'vuex-toast'
  import getCallHistory from './../../gql/queries/PBX/getIncomingCalls.graphql'
  import getAudioRecordsQuery from './../../gql/queries/PBX/getAudioRecords.graphql'

  export default {
    name: 'history',
    props: ['order'],
    data () {
      return {
        loading: false,
        itemsPage: {
          incomingCalls: null,
          paginator: {
            total_count: 10
          }
        },
        params: {
          page: 1
        },
        loadingRecords: false
      }
    },
    computed: {
      items () {
        this.incomingCallsCache = JSON.parse(JSON.stringify(this.itemsPage.incomingCalls))
        return this.incomingCallsCache
      },
      ...mapState({
        currentUser: state => state.globalStore.user
      })
    },
    methods: {
      loadRecords (pbxCallId, index) {
        this.loadingRecords = pbxCallId
        this.$apollo.query({
          query: getAudioRecordsQuery,
          variables: {
            pbxCallId
          }
        }).then(result => {
          this.incomingCallsCache[index].records = result.data.audioRecords
          this.loadingRecords = false
        }).catch(error => {
          console.log(error)
          this.addToast({
            text: 'Произошла ошибка:' + error,
            type: 'danger',
            dismissAfter: 10000
          })
          this.loadingRecords = false
        })
      },
      ...mapActions({
        addToast: ADD_TOAST_MESSAGE
      })
    },
    mounted () {
      if (this.order.clientPhone.length > 3) {
        this.$apollo.queries.itemsPage.skip = false
      }
    },
    apollo: {
      itemsPage: {
        query: getCallHistory,
        variables () {
          return {
            page: this.params.page,
            query: this.order.clientPhone
          }
        },
        watchLoading (isLoading) {
          this.loading = isLoading
        },
        fetchPolicy: 'network-only',
        update: (data) => {
          return data
        },
        skip: true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// OrderCallHistory.vue?7699c0cd